import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "../base-service";
import {AppConfig} from "../../config/appconfig";
import {Observable} from "rxjs/Observable";
import { Storage } from '@ionic/storage';

/*
  Generated class for the CommandsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class CommandsProvider extends BaseService{

  private readonly commandsUrl = AppConfig.apiBaseUrl + '/commands/';

  constructor(
    public http: Http,
    public storage: Storage
  ) {
    super(http, storage);
  }

  public activate(vehicleId: number, num: number): Observable<any>{
    let url = this.commandsUrl + `vehicle/${vehicleId}/activate/${num}`;

    return this.http.post(
      url,
      null,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }

  public deactivate(vehicleId: number, num: number): Observable<any>{
    let url = this.commandsUrl + `vehicle/${vehicleId}/deactivate/${num}`;

    return this.http.post(
      url,
      null,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let body = res.json();
        var d = body || {};
        return d;
      });
      //.catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/providers/commands/commands.ts